import { Injectable } from '@angular/core';

@Injectable()
export class ErpApiService {

  baseUrl = 'http://103.253.72.142:8000/api/'

  constructor() {

    $.ajaxSetup({
        headers: {
            'Content-Type': 'application/json'
        }
    })
  }
  getHost(uri){

    let arr = uri.split('/')
    let map = {
      organization: 'http://103.253.72.142:9000/api/',
      hr: 'http://103.253.72.142:8000/api/',
      crm: 'http://103.253.72.142:5000/api/',
      servicepackage:'http://103.253.72.142:6969/api/',
      upload:'http://103.253.72.142:7000/api/'
    }
    let url = map[arr[0]] + uri
    return url
  }
  parsseResponse(res){

    if(res.statusCode != 1){
      throw Error(res.message)
    }
    return res
  }
  delete(uri, params = null) {

      return $.ajax({
          method: 'DELETE',
          url: this.getHost(uri),
          data: JSON.stringify(params)
      }).then(this.parsseResponse)
  }
  put(uri, params = null) {

      return $.ajax({
          method: 'PUT',
          url: this.getHost(uri),
          data: JSON.stringify(params)
      }).then(this.parsseResponse)
  }
  get(uri, params = null) {

      return $.get(this.getHost(uri), JSON.stringify(params)).then(this.parsseResponse)
  }
  post(uri, params = null) {

      return $.post(this.getHost(uri), JSON.stringify(params)).then(this.parsseResponse)
  }

}



// WEBPACK FOOTER //
// ./src/app/services/erp-api.service.ts